import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { on, addClass, selectAll } from 'helpers/dom'
import { map } from 'helpers/utils'
import { trapFocus, removeTrapFocus } from 'libs/accessibility'

const selectors = {
  CLOSE_SELECTOR: '.js-close-modal-dialog',
  CONTENT_SELECTOR: '.js-content-modal-dialog',
  OPEN_CLASS: 'modal-dialog-opened',
  OPEN_SELECTOR: '.modal-dialog-opened',
  OVERLAY_CLASS: 'modal-dialog-overlay',
  VALIDATE_FORM_CLASS: 'validate-form',
  TIMEOUT: 200,
  VIDEO_PLAYER: 'video-player'
}

class ModalDialog extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  init() {
    this.closeBtn = this.querySelectorAll(selectors.CLOSE_SELECTOR)
    this.contentEl = this.querySelector(selectors.CONTENT_SELECTOR)
    this.videoPlayers = this.querySelectorAll(selectors.VIDEO_PLAYER)
    this.isSlideOut = this.dataset && this.dataset.type === 'slideout'
    this.scrollTarget = this.getAttribute('data-scroll-target')
    this.attachEvents()
    this.addOverlay()
  }

  attachEvents() {
    this.closeBtn.forEach((btn) => on('click', this.hide.bind(this), btn))
    on('click', this.hide.bind(this), this)
    this.contentEl && on('click', (e) => e.stopPropagation(), this.contentEl)
    on(
      'keyup',
      (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE') this.hide()
      },
      this
    )
  }

  addOverlay() {
    if (this.isSlideOut && !this.overlayEl) {
      this.overlayEl = document.createElement('div')
      addClass(selectors.OVERLAY_CLASS, this.overlayEl)
      this.insertBefore(this.overlayEl, this.contentEl)
    }
  }

  show(target, init = false) {
    this.triggerEl = document.activeElement

    init && this.init()
    /** Hide all opened modal before open new modal */

    const allModals = document.querySelectorAll(selectors.OPEN_CLASS)

    allModals.forEach((modal) => modal.hide())

    this.setAttribute('open', '')
    this.classList.add(selectors.OPEN_CLASS)

    if (!target) {
      if (this.scrollTarget) {
        const scrollTargetEl = selectAll(this.scrollTarget, this)

        map(disableBodyScroll, [...scrollTargetEl, this.contentEl])
      } else {
        disableBodyScroll(this.contentEl)
      }
    } else {
      disableBodyScroll(target)
    }

    setTimeout(() => {
      trapFocus(this.contentEl)
    }, selectors.TIMEOUT)
  }

  hide() {
    /** Refresh validate form when hide modal */
    const allFormsValidate = this.querySelectorAll(
      selectors.VALIDATE_FORM_CLASS
    )

    allFormsValidate.forEach((form) => form.refreshValidate())
    this.videoPlayers && this.videoPlayers.forEach((video) => video.pause())

    this.removeAttribute('open')
    this.classList.remove(selectors.OPEN_CLASS)

    const allModals = document.querySelectorAll(selectors.OPEN_SELECTOR)

    if (allModals.length < 1) {
      clearAllBodyScrollLocks()
    }

    this.dispatchEvent(new Event('close-modal'))
    removeTrapFocus()
    setTimeout(() => {
      this.triggerEl && this.triggerEl.focus()
    }, selectors.TIMEOUT)
  }
}

customElements.define('modal-dialog', ModalDialog)
